import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type')({
  beforeLoad: () => getTitleContextSlice('Mapping'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
